import React from 'react';
import cn from 'classnames';
import { useEditorContainerSize } from '@wix/da-editor-tiptap/pkg/components/Editor/Context';
import StatusDumbView from '../../../DeviationViews/Dumbo/Status';
import { Props } from '../MonoView';
import EditorDeviationLink from '../_partials/DeviationLink';
import { useFreeformSquareSizing } from '../helpers';

import s from './Status.scss';

const StatusMonoView: React.FC<Props> = props => {
  const containerSize = useEditorContainerSize();
  const { deviation, extOptions, width: propsWidth, link } = props;
  const size = useFreeformSquareSizing(propsWidth, extOptions, containerSize);

  return (
    <div className={cn(s['root'])} style={{ width: size.width }}>
      <EditorDeviationLink link={link} deviation={deviation}>
        <StatusDumbView width={size.width} height={size.height} deviation={deviation} />
      </EditorDeviationLink>
    </div>
  );
};
StatusMonoView.displayName = 'StatusMonoView';

export default StatusMonoView;
